import request from 'api/requestUtils'
import config from 'constants/config'
import qs from 'qs'

interface GetMyCartsCart {
  transactionKey: string
  type: 'pending' | 'abandoned' | 'completed' | 'purchased'
  createdAt: number
  updatedAt: number
  brand: string
  currency?: string
  total?: number
  // svc-cart's contract marks this required, but omits it for carts stored without items.
  rawItems?: Array<App.Checkout.AnyItem>
}

interface GetMyCartsResponse {
  result: Array<GetMyCartsCart>
}

export async function getMyCarts(): Promise<{ carts: Array<App.SpoofUserCart> }> {
  const query = qs.stringify({
    brand: config.BRAND,
    page: 0,
    limit: 50,
    sortDir: 'DESC',
    statuses: ['abandoned'],
  }, { arrayFormat: 'brackets' })

  const response = await request.get<GetMyCartsResponse>(`/api/carts/me?${query}`, {
    credentials: 'include',
    excludeBrand: true,
  })

  const carts = response.result
    .filter(cart => cart.type === 'abandoned')
    .map((cart): App.SpoofUserCart => ({
      transactionKey: cart.transactionKey,
      type: 'abandoned',
      createdAt: cart.createdAt,
      updatedAt: cart.updatedAt,
      brand: cart.brand,
      currency: cart.currency,
      total: cart.total,
      rawItems: cart.rawItems ?? [],
    }))

  return {
    carts,
  }
}
